import React, { useMemo } from 'react';
import DataTable from '../DataTable';
import './WorkspaceDataTable.scss';

/**
 * Standard workspace table — search, sort, filter, pagination, export (client-side).
 * Use on all Dhruv Workspace / platform list pages for consistent UX.
 */
const WorkspaceDataTable = ({
  data = [],
  rowIdKey = '_id',
  showCheckboxes = false,
  pageSize = 10,
  className = '',
  ...rest
}) => {
  const rows = useMemo(
    () => (data || []).map((row) => ({
      ...row,
      id: row.id ?? row[rowIdKey] ?? row._id
    })),
    [data, rowIdKey]
  );

  return (
    <DataTable
      data={rows}
      rowIdKey={rowIdKey}
      showCheckboxes={showCheckboxes}
      pageSize={pageSize}
      searchable
      sortable
      pagination
      exportable
      className={`workspace-datatable ${className}`.trim()}
      {...rest}
    />
  );
};

export default WorkspaceDataTable;
